import { randomString } from '../../../util/randomString';
import { SESSION_STORAGE_KEYS } from '../../common/constants/sessionStorageKeys';

function getAvailableStateValues<PayloadType>(): { [state: string]: PayloadType } {
    const stateListString = sessionStorage.getItem(SESSION_STORAGE_KEYS.AUTHENTICATION_STATE_VALUES);

    if (!stateListString) {
        return {};
    }

    return JSON.parse(stateListString);
}

function generateAndStoreState<PayloadType>(payload: PayloadType) {
    const generatedNonce = randomString(12);
    const existingStates = getAvailableStateValues<PayloadType>();

    existingStates[generatedNonce] = payload;

    sessionStorage.setItem(SESSION_STORAGE_KEYS.AUTHENTICATION_STATE_VALUES, JSON.stringify(existingStates));

    return generatedNonce;
}

function getStoredState<PayloadType>(nonce: string): PayloadType | null {
    const existingStates = getAvailableStateValues<PayloadType>();
    const existingPayload = existingStates[nonce];

    if (!existingPayload) {
        return null;
    }

    return existingPayload;
}

export { generateAndStoreState, getStoredState };
